import { render, staticRenderFns } from "./Nlp.vue?vue&type=template&id=64e93030&"
import script from "./Nlp.vue?vue&type=script&lang=js&"
export * from "./Nlp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports